import { Form } from "antd";
import StateDropdown from "../misc/StateDropdown";
import CountryDropdown from "../misc/CountryDropdown";
import { UnitedStates } from "../../../util/countries";

interface BillingAddressParams {
  address: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  onChangeClick: (type: string, value: string) => void;
}

export default function BillingAddress({
  address,
  address2,
  city,
  state,
  country,
  zip,
  onChangeClick,
}: BillingAddressParams) {
  return (
    <section className={"billing"}>
      <h5>Billing Address</h5>
      <Form.Item
        name="address"
        rules={[{ required: true, message: "Street Address required" }]}
      >
        <div className={"blk"}>
          <label>Street Address</label>
          <input
            tabIndex={3}
            type={"text"}
            placeholder={"Address"}
            value={address}
            onChange={(ev) => onChangeClick("address", ev.target.value)}
          />
        </div>
      </Form.Item>

      <Form.Item name="address2">
        <div className={"blk"}>
          <label>Street Address Line 2 (optional)</label>
          <input
            tabIndex={3}
            type={"text"}
            placeholder={"Address"}
            value={address2}
            onChange={(ev) => onChangeClick("address2", ev.target.value)}
          />
        </div>
      </Form.Item>

      <Form.Item
        name="city"
        rules={[{ required: true, message: "City required" }]}
      >
        <div className={"blk"}>
          <label>City</label>
          <input
            tabIndex={5}
            type={"text"}
            placeholder={"City"}
            value={city}
            onChange={(ev) => onChangeClick("city", ev.target.value)}
          />
        </div>
      </Form.Item>

      <div className={"blk row"}>
        <Form.Item
          name="state"
          shouldUpdate={(prevValues, currentValues) =>
            prevValues !== currentValues
          }
          rules={[{ required: true, message: "State/Province required" }]}
        >
          <div className={"col"}>
            <label>State / Province</label>
            {country === UnitedStates && (
              <StateDropdown
                onChange={(v) => onChangeClick("state", v)}
                defaultValue={state}
                tabIndex={6}
              />
            )}
            {country !== UnitedStates && (
              <input
                tabIndex={6}
                type={"text"}
                placeholder={"State / Province"}
                value={state}
                onChange={(ev) => onChangeClick("state", ev.target.value)}
              />
            )}
          </div>
        </Form.Item>

        <Form.Item
          name="zip"
          rules={[{ required: true, message: "ZIP/Postal Code required" }]}
        >
          <div className={"col"}>
            <label>ZIP / Postal Code</label>
            <input
              tabIndex={7}
              type={"text"}
              placeholder={"ZIP / Postal Code"}
              value={zip}
              onChange={(ev) => onChangeClick("zip", ev.target.value)}
            />
          </div>
        </Form.Item>
      </div>
      <Form.Item
        name="country"
        shouldUpdate={(prevValues, currentValues) =>
          prevValues !== currentValues
        }
        rules={[{ required: true, message: "Country required" }]}
      >
        <div className={"blk"}>
          <label>Country</label>
          <CountryDropdown
            onChange={(v) => onChangeClick("country", v)}
            defaultValue={country}
            tabIndex={8}
          />
        </div>
      </Form.Item>
    </section>
  );
}
